import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, NgForm } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { map, Observable } from 'rxjs';
import { Alert, AlertType } from '../../shared/alert.model';
import { getAlertMessage } from '../../shared/api-loaders';
import { ClaimsService } from '../../shared/claims.service';
import { getDefaultDataTableDefinitionLocalProcessing } from '../../shared/DataTablesHelper';
import { MessageService } from '../../shared/message.service';
import { MessageType } from '../../shared/messageType';
import { SecurityService } from '../../shared/security.service';
import { Parameter } from '../models/parameter';
import { Select2Option } from '../../shared/select2-option';
import { ParametersDeleteConfirmationDialogComponent } from '../parameters-delete-confirmation-dialog/parameters-delete-confirmation-dialog.component';
import { ConfigurationService } from '../services/configuration.service';
import { CustomerService } from '../services/customer.service';
import { ParameterService } from '../services/parameter.service';
import { CustomValidators } from '../validators/blank-validator';
import { ParameterValueValidator } from '../validators/parameter-value-validator';

@Component({
    selector: 're-customer-parameters',
    templateUrl: './customer-parameters.component.html',
    styleUrls: ['./customer-parameters.component.scss'],
    standalone: false
})
export class CustomerParametersComponent implements OnInit {

  constructor(
    private customerService: CustomerService,
    private messages: MessageService,
    private parameterService: ParameterService,
    private securityService: SecurityService,
    private fb: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private claimsService: ClaimsService,
    private messageService: MessageService,
    private modalService: NgbModal,

  ) { }


  @Input()
  customerId: number;
  loading = false;
  data: any[];
  public groupedParameters: any;
  isReadOnlyUser = true;
  gsEnabled = false;
  parameter = new Parameter();
  newParameter: boolean;
  editProfile = false;
  errorMessage:string;
  addError=false;

  resetFlags() {
    this.editProfile = false;
    this.load();
  }


  public parameterId: number;
  successAlert: Alert;
  hasGlobalError = false;
  alert: Alert;
  showMessage = false;

  clearAlerts() {

    this.hasGlobalError = false;
    setTimeout(() => {
      this.alert = null;
      this.showMessage = false;
    }, 5000);
  }


  @ViewChild('parameterKey')
  parameterKey: ElementRef<HTMLInputElement>;

  async addParameter() {
    const parameter = new Parameter(this.parameterDetailForm.value);
    for (let p of this.data) {
      var exists = this.data.filter(x => x.key.trim() === parameter.key.trim());
      if(exists.length>0){
        this.errorMessage="Key already exists and cannot be re-added.";
        this.addError=true;
        this.loading=false;
        break;
      }
    }
    if(!this.addError){
      try {
        this.newParameter = true;
        parameter.customerId = this.customerId;
        //parameter.stackId = this.stackId;
        parameter.createdBy = this.username;
        delete parameter.environmentKey;
        delete parameter.corpOid;
        delete parameter.id;
        var data = await this.parameterService.addParameter(parameter).toPromise();
        this.messageService.sendSaveSuccess("Parameter");
        this.resetFlags();
        this.clearAlerts();

        this.parameterDetailForm.patchValue({
          key: "",
          value: ""
        });
      } catch (e) {
        this.messages.sendError(getAlertMessage(e).message);
      }
      this.parameterDetailForm.markAsUntouched();
    }
  }

  async cancelParameters() {
    this.editParameters = false;
    $('#cb_slselectall').prop('checked', false);
    this.uncheckAllCheckBox();
    await this.load();
    this.loading = false;
  }
  uncheckAllCheckBox() {
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(x =>
        x.checked = false);
      this.somethingIsChecked = false;
    });
  }

  async updateParameter() {
    this.newParameter = false;
    let parameterObject = [];

    Object.keys(this.groupedParameters).forEach(groupName => {
      var newParameterRow;
      var oldParameterRow;
      for (var i = 0; i < this.groupedParameters[groupName].length; i++) {
        newParameterRow = this.groupedParameters[groupName][i];
        oldParameterRow = this.groupedParametersOld[groupName].filter(x => x.id ==newParameterRow.id)[0];
        if (JSON.stringify(newParameterRow.key) === JSON.stringify(oldParameterRow.key) &&
          JSON.stringify(newParameterRow.value) === JSON.stringify(oldParameterRow.value)) {
        }
        else {
          let obj = {
            customerId: this.customerId,
            id: this.groupedParameters[groupName][i].id,
            key: this.groupedParameters[groupName][i].key,
            value: this.groupedParameters[groupName][i].value,
            modifiedBy: this.username
          };
          parameterObject.push(obj);
        }
      }
    });

    if (parameterObject.length > 0) {
      try {
        await this.parameterService.updateBatchParameter(this.customerId, parameterObject).toPromise();
        this.messages.sendSaveSuccess("Parameter");
        // If customer was updated successfully, id must have some value.
        this.resetParameterFlags();
        this.resetFlags();
        this.editParameters = false;
      } catch (e) {
        this.messages.sendError(getAlertMessage(e).message);
      }
    }
  }

  resetParameterFlags() {
    this.editParameters = false;
  }

  public groupedParametersOld: any;
  deleteParameterIds: number[] = [];

  editParameters = false;
  somethingIsChecked = false;

  editParametersClicked() {
    this.editParameters = true;
    this.customerService.getParameters(this.customerId).subscribe(data => {
      this.groupedParametersOld = this.groupByProductName(data);
    });

  }

  deleteBatchParameters() {
    this.deleteParameterIds = [];
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(x => {
        if (x.checked) {
          this.deleteParameterIds.push(x.id);
        }
      });
    });
    if (this.deleteParameterIds.length > 0) {
      this.showBulkParameterDeleteConfirmationWindow();
    }
    this.editParameters = false;
    this.somethingIsChecked = false;
  }
  checkAllCheckBox(ev) {
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(x =>
        x.checked = ev.target.checked);
      this.somethingIsChecked = ev.target.checked;
    });
  }
  onCheck() {
    this.somethingIsChecked = false;
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(u => {
        if (u.checked) {
          this.somethingIsChecked = true;
        }
      });
    });
  }

  confirmationWindowRef: NgbModalRef;

  async showBulkParameterDeleteConfirmationWindow() {
    this.confirmationWindowRef = this.modalService.open(ParametersDeleteConfirmationDialogComponent);
    const comp = <ParametersDeleteConfirmationDialogComponent>this.confirmationWindowRef.componentInstance;
    const result: any = await this.confirmationWindowRef.result;

    if (result) {
      this.parameterService.deleteBatchParameter(this.deleteParameterIds.toString()).subscribe(
        res => {
          //  this.resetParameterFlags();
          this.messages.sendDeleteSuccess("Parameter");
          this.refreshParams();
          this.editParameters = false;

        },
        error => {
          this.alert = getAlertMessage(error);
        }
      );
    }

  }
  isError = false;
  async refreshParams() {
    this.isError = false;
    await this.load();

  }
  public checkSelect() {

    if (this.parameterDetailForm.get('key').value.includes('bp.globalsearch.displayformat')) {
      this.gsEnabled = true;
      return true;
    } else if (this.parameterDetailForm.get('key').value.includes('enabled') || this.parameterDetailForm.get('key').value.includes('isdefault')) {
      return true;
    } else {
      this.gsEnabled = false;
      return false;
    }
  }

  public checkSelectMultiEdit(key) {
    this.gsEnabled = false;
    if (key.includes('bp.globalsearch.displayformat')) {
      this.gsEnabled = true;
      return true;
    } else if (key.includes('enabled') || key.includes('isdefault')) {
      return true;
    } else {
      this.gsEnabled = false;
      return false;
    }
  }

  parameterDetailForm: UntypedFormGroup = this.fb.group({
    id: [''],
    configurationId: [''],
    key: ['', CustomValidators.blankValidator],
    value: ['', null, _ => ParameterValueValidator.validate2(this.parameterDetailForm?.controls['value'], this.parameterDetailForm?.controls['key'], this.corpOid, this.snfAppUrl, this.configurationService, this.customerService, null, null, false)],
    environmentKey: ['']
  });

  public checkDefaultText() {
    this.errorMessage="";
    this.addError=false;
    if (this.parameterDetailForm.get('key').value.includes('bp.globalsearch.displayformat')) {
      this.gsEnabled = true;
      return 'First Name \"Preferred Name\" Last Name';
    } else {
      this.gsEnabled = false;
      return 'False';
    }
  }

  public checkDefaultTextMultiEdit(key) {
    if (key.includes('bp.globalsearch.displayformat')) {
      return 'First Name \"Preferred Name\" Last Name';
    } else {
      return 'False';
    }
  }

  public getProductKeys(): Array<string> {
    if (!this.groupedParameters)
      return [];

    return Object.keys(this.groupedParameters).sort((a, b) => a.localeCompare(b));
  }

  public isProductCollapsed: { [key: string]: boolean } = {};
  expandAll() {
    var keys = this.getProductKeys();
    keys.forEach(x => this.isProductCollapsed[x] = false);
  }

  collapseAll() {
    var keys = this.getProductKeys();
    keys.forEach(x => this.isProductCollapsed[x] = true);
  }

  getNgStyleColorBasedOnStatus(status) {
    if (status === 'LOADING') {
      return '#141888';
    } else if (status === 'UP') {
      return '#26882B';
    } else if (status === 'DOWN') {
      return '#ff0000';
    } else {
      return '#1e2aff';
    }
  }
  username: string;

  async load() {
    if (this.customerId) {
      this.loading = true;
      this.messages.clearErrorAlert();
      this.customerService.getParameters(this.customerId).subscribe(x => {
        this.data = x;
        this.groupedParameters = this.groupByProductName(x);
        this.callHealthchecks();

        this.loading = false;
      }, e => {
        this.messages.sendError(getAlertMessage(e).message);
        this.loading = false;
      });
    }


    var products = await this.parameterService.getProductNames().toPromise();
    products.forEach(x => {
      this.productNames[x.key] = x.name;
    });
  }
  async ngOnInit() {

    this.isReadOnlyUser = await this.securityService.isThisReadOnlyUser();
    this.username = this.claimsService.getPreferredName();
    await this.loadOptions();

    await this.load();

  }
  enabledDisableData: Select2Option[];
  gsEnabledData: Select2Option[];
  private async loadOptions() {
    await this.parameterService.getEnableDisableOptions().pipe(map(data => {
      this.enabledDisableData = data
    })).toPromise();
    await this.parameterService.getGSDisplayOptions().pipe(map(data => {
      this.gsEnabledData = data
    })).toPromise();
  }

  snfApiKey = 'snf.api.url.root';
  mcslApiKey = 'sl.api.url.root';
  snfCorpOidKey = 'snf.corpOid';
  snfAppUrlKey = 'snf.app.url.root';
  corpOid: any = null;
  snfAppUrl: any = null;

  callHealthchecks() {
    Object.keys(this.groupedParameters).forEach(groupName => {
      this.groupedParameters[groupName].forEach(async parameter => {
        // Call Health Check to Check SNF/SL Api
        if ((parameter['key'] === this.snfApiKey || parameter['key'] === this.mcslApiKey) && parameter.hasOwnProperty('value') && parameter['value'] !== '') {
          parameter['status'] = 'LOADING';
          await this.parameterService.getApiHealthchecks(parameter['key'], parameter['value']).subscribe(result => {
            parameter['status'] = result['status'];
            if (parameter['status'] === 'DOWN') {
              parameter['errorMessage'] = 'API service is unavailable.';
            }
          });
        }
        if ((parameter['key'] === this.snfAppUrlKey) && parameter.hasOwnProperty('value') && parameter['value'] !== '') {
          this.snfAppUrl = parameter.value;
        }
        if ((parameter['key'] === this.snfCorpOidKey) && parameter.hasOwnProperty('value') && parameter['value'] !== '') {
          this.corpOid = parameter.value;
        }
      });
    });
  }

  onChange(value: string, event: KeyboardEvent, key: string) {
    //this ensures that the two properties are updated BEFORE the validator is called as we need them for valdiation
    if (key.toLowerCase().includes("snf.corpoid")) {
      var corpOid = Number((value || "") + event.key);
      this.corpOid = corpOid;
      console.log("value in on change", value, event.key, corpOid, key);
    }

    if (key.includes("snf.app.url.root")) {
      var snfAppUrl = (value || "") + event.key;
      this.snfAppUrl = snfAppUrl;
      console.log("value in on change", value, event.key, snfAppUrl, key);
    }

  }


  @Input()
  products: any[]


  groupByProductName(parameters: any[]): any {
    const groups = {};

    for (const x of parameters) {
      const productName = x.key.split('.')[0];
      // if (productName === 'provision') {
      //   continue;
      // }
      const displayName = this.getProductDisplayName(productName);
      groups[displayName] = groups[displayName] || [];
      groups[displayName].push({ ...x, status: '', errorMessage: '' });
    }

    return groups;
  }
  private productNames = {};

  getProductDisplayName(productName: any): any {
    if (this.productNames[productName])
      return this.productNames[productName];

    return productName;
  }
}
